import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { SectionHeading } from "@/components/Bits";

export default function Ingredients() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/ingredients").then(({ data }) => setItems(data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-5 md:px-8 pt-14 pb-24">
      <SectionHeading eyebrow="Ingredient Library" title="Explore our ingredients" subtitle="A closer look at the natural ingredients behind the ASURE range." />
      <div className="mt-14 grid md:grid-cols-2 gap-8">
        {items.map((ing, i) => (
          <div key={ing.slug} className={`card-surface overflow-hidden ${i % 3 === 0 ? 'md:col-span-2' : ''}`} data-testid={`ing-${ing.slug}`}>
            <div className={`grid ${i % 3 === 0 ? 'md:grid-cols-2' : ''}`}>
              <img src={ing.image} alt={ing.name} className={`w-full ${i % 3 === 0 ? 'h-72 md:h-full' : 'h-64'} object-cover`} />
              <div className="p-8">
                <div className="eyebrow">{ing.tagline}</div>
                <h3 className="font-display text-4xl mt-3">{ing.name}</h3>
                <p className="mt-4 text-asure-text2">{ing.what_it_is}</p>
                <div className="mt-4 grid grid-cols-1 gap-2 text-sm text-asure-text2">
                  <div><span className="font-semibold text-asure-forest">Source: </span>{ing.source}</div>
                  <div><span className="font-semibold text-asure-forest">Components: </span>{ing.components}</div>
                  <div><span className="font-semibold text-asure-forest">In ASURE: </span>{ing.asure_uses}</div>
                </div>
                <div className="mt-4 flex gap-2 flex-wrap">
                  {ing.formats?.map((f) => <span key={f} className="text-[11px] font-semibold tracking-wide px-3 py-1 rounded-full border border-asure-forest/30 text-asure-forest">{f}</span>)}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
